import React, { memo } from 'react';

import { Aisle } from './Aisle/Aisle';
import { EmptySeat } from './EmptySeat/EmptySeat';
import { Seat } from './Seat/Seat';
import { SeatType } from './constants';

export const Cell = memo(({ cellKey, aisleRef, seat, nextSeat, rowLength, maxWidth, gridWidth, joinAisleOffset, seatStyle }) => {
    const isAisle = seat.type === SeatType.AISLE;
    const isAisleNext = isAisle && nextSeat && nextSeat.type === SeatType.AISLE;

    if (isAisleNext) {
        aisleRef.current++;
    } else if (!isAisle) {
        aisleRef.current = 1;
    }

    const widthJoinAisle = aisleRef.current > 1 && !isAisleNext && (gridWidth / rowLength) * aisleRef.current - joinAisleOffset;

    return seat.type === SeatType.AISLE ? (
        !isAisleNext && <Aisle key={cellKey} seat={seat} maxWidth={maxWidth} widthJoinAisle={widthJoinAisle} />
    ) : seat.type === SeatType.SEAT ? (
        <Seat key={cellKey} seat={seat} maxWidth={maxWidth} style={seatStyle} />
    ) : (
        <EmptySeat key={cellKey} seat={seat} maxWidth={maxWidth} style={seatStyle} />
    );
});
